<template>
  <div class="container-fluid welcome-page">

<!--    <div class="black-back">
      <img @click="goToProjects" class="welcome-gif" :src=this.welcomeImage>
      <div class="skip" @click="goToProjects">
    </div>

      Skip this
    </div>-->
    <!--<img class="img-fluid img-hippo" v-for="image in images" :src="image.src" :srcset="image.srcset" :alt="image.alt" v-if="image.visible" v-on:load="onload">

    <div class="hippo-bg" v-if="visible">
      <div class="hippo-opacity" v-bind:class="{ active: comeInside }">
        <div>
          &lt;!&ndash;<img class="gif" @click="goToProjects" src="/static/img/welcome.gif" width=400/>&ndash;&gt;
          <div class="skip" @click="goToProjects">
            Skip this
          </div>
          &lt;!&ndash;<div class="hippo-path">
            <img src="/static/img/hippotec_path.svg" alt="Hippotec">
          </div>
          <div class="hippo-text" v-bind:style="{'font-size': this.jumpTextFontSise}">
            <router-link tag="a" to="/projects"></router-link>
            <vue-typer :text='["WELCOME TO HIPPOTEC", "UX/UI & TECHNOLOGY STUDIO", "VIEW OUR WORK"]'
                       erase-style='backspace'
                       :pre-type-delay='400'
                       :erase-delay='20'
                       caret-animation='solid'
                       @typed='onTyped'
                       @typed-char='onTypedChar'
                       @erased='onErased'
                       @completed='onComplete'
                       :repeat='0'></vue-typer>
          </div>&ndash;&gt;
        </div>
      </div>
    </div>-->

  </div>
</template>

<script>
export default {
  name: 'Welcome',
  data() {
    return {
      welcomeImage: '',
      images: [
        { src: '/static/img/welcome.gif', visible: true, alt: 'Hippotec' }
      ],
      index: 0,
      image: null,
      visible: false,
      comeInside: true,
      completed: false,
      isMobile: false,
      jumpTextFontSise: "40px"
    }
  },
  methods: {
    goToProjects() {
      this.$router.push("/what-we-do");
    },
    checkIsMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    onload() {
      this.visible = true;
    },
    onTyped: function() {
      // console.log('onTyped');
    },
    onTypedChar: function(typedChar, typedCharIndex) {
      // console.log('typedChar:', typedChar);
      // console.log('typedCharIndex:', typedCharIndex);
    },
    onErased: function(erasedString) {
      // console.log('onErased:', erasedString);

      if ((this.images.length - 1) > this.index) {
        this.images[this.index].visible = false;
        this.index++;
      }

    },
    onComplete: function () {
      this.completed = true
      // console.log('onComplete');
    },
    prepareMobile(isMobile) {
      this.isMobile = isMobile;
      if(isMobile){
        this.jumpTextFontSise = "30px"
        this.welcomeImage = '/static/img/welcome_mobile.gif'
      }else{
        this.welcomeImage = '/static/img/welcome_web.gif'
      }
    }
  },
  created: function () {
    this.images[0].visible = true;
    var isMobile = this.checkIsMobile();
    localStorage.isMobile = isMobile;
    this.prepareMobile(isMobile);
    this.goToProjects()
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/welcome";
  .black-back {
    background-color: #0b2e13;
    width: 100%;
    height: 100%;
  }
  .hippo-text {
    padding: 0 15px;
    font-weight: 300;
    position: relative;
  }
  .welcome-gif {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .gif {
    cursor: pointer;
  }
  .skip {
    cursor: pointer;
    color: white;
    font-size: 25px;
    font-family: Rubik, sans-serif;
    font-weight: 200;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    margin-bottom: 50px;
    text-decoration: underline;
    letter-spacing: 1px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Welcome.vue